function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as actionTypes from './actionTypes';
import { DAYS_SELECTOR_ZOOM } from './constants';
const initialState = {
    showMedian: true,
    showIQR: true,
    showP10P90: true,
    dailyRecords: [],
    highlightedDates: [],
    daysSelectorZoom: DAYS_SELECTOR_ZOOM.day,
    daysSelectorPage: 0,
    agpMonthSelectorPage: 0,
    aggregations: [],
    aggregationDocumentsIds: [],
    preview: {
        days: [],
        weeks: [],
        months: []
    },
    agpPreview: {
        days: [],
        months: []
    },
    list: [],
    fetching: [],
    sending: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_AGP_DAILY_RECORDS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    dailyRecords: action.payload.dailyRecords
                });
            }
        case actionTypes.SELECT_HIGHLIGHTED_DATES:
            {
                const range = action.payload;
                const availableDates = state.preview.days.map(({ date })=>date);
                const startDate = range.start < range.end ? range.start : range.end;
                const endDate = range.start < range.end ? range.end : range.start;
                const newHighlightedDates = availableDates.filter((availableDate)=>availableDate >= startDate && availableDate <= endDate);
                return _object_spread_props(_object_spread({}, state), {
                    highlightedDates: newHighlightedDates
                });
            }
        case actionTypes.RESET_HIGHLIGHTED_DATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    highlightedDates: state.highlightedDates.filter((date)=>date !== action.payload)
                });
            }
        case actionTypes.CLEAR_HIGHLIGHTED_DATES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    highlightedDates: []
                });
            }
        case actionTypes.SET_DAYS_SELECTOR_ZOOM:
            {
                return _object_spread_props(_object_spread({}, state), {
                    daysSelectorZoom: action.payload.zoom
                });
            }
        case actionTypes.SET_DAYS_SELECTOR_PAGE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    daysSelectorPage: action.payload.page
                });
            }
        case actionTypes.SET_AGP_MONTH_SELECTOR_PAGE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    agpMonthSelectorPage: action.payload.page
                });
            }
        case actionTypes.SET_PREVIEW:
            {
                return _object_spread_props(_object_spread({}, state), {
                    preview: action.payload.preview
                });
            }
        case actionTypes.SET_AGP_PREVIEW:
            {
                return _object_spread_props(_object_spread({}, state), {
                    agpPreview: action.payload.preview
                });
            }
        case actionTypes.APPEND_AGGREGATIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    aggregations: [
                        ...state.aggregations,
                        ...action.payload.aggregations
                    ],
                    aggregationDocumentsIds: [
                        ...state.aggregationDocumentsIds,
                        ...action.payload.aggregationDocumentsIds
                    ]
                });
            }
        case actionTypes.RESET_AGGREGATIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    aggregations: [],
                    aggregationDocumentsIds: []
                });
            }
        case actionTypes.SET_SHOW_MEDIAN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    showMedian: action.payload.showMedian
                });
            }
        case actionTypes.SET_SHOW_IQR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    showIQR: action.payload.showIQR
                });
            }
        case actionTypes.SET_SHOW_P10P90:
            {
                return _object_spread_props(_object_spread({}, state), {
                    showP10P90: action.payload.showP10P90
                });
            }
        default:
            {
                return state;
            }
    }
}
